import { render, staticRenderFns } from "./kematian.vue?vue&type=template&id=617325a8&"
import script from "./kematian.vue?vue&type=script&lang=js&"
export * from "./kematian.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports